// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"35e94a15","732":"76afbde9","977":"8171c4bd"}[chunkId] + ".chunk.js";
};